export enum PAYOUT_TYPES {
  PAY_STUBS = 'Pay Stubs',
  TAX_FORMS = 'Tax Forms',
}
